import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExceptionService {

  private _exception: boolean = false;

  public get exception(): boolean {
    return this._exception;
  }

  /**
   * Create an exception.
   */
  public newException(): void {
    this._exception = true;
  }

  /**
   * Clear exception.
   */
  public clearException(): void {
    this._exception = false;
  }
}